namespace TabAurous.Inventory {
    export namespace CustomerRepairItemsService {
        export const baseUrl = 'Repair/CustomerRepairItems';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<RepairItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Repair/CustomerRepairItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>CustomerRepairItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
